module.exports = "/fonts/vendor/primeicons/primeicons.woff?3b6e3706f42d8876fe364ab4d75683fd";